import React from 'react';
import { Ic } from './Icons';

export default function AppHeader({ onMenuOpen, isPostEvent }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '18px 20px 18px',
        flexShrink: 0,
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <img
          src="/elx-logo-white.png"
          alt="ELX"
          style={{ height: 36, objectFit: 'contain', alignSelf: 'flex-start' }}
        />
        <span
          style={{
            fontSize: 10,
            fontWeight: 500,
            color: 'rgba(255,255,255,0.42)',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
          }}
        >
          Executive Leadership Exchange
        </span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            background: isPostEvent ? 'rgba(148,163,184,0.12)' : 'rgba(34,197,94,0.14)',
            border: `1px solid ${
              isPostEvent ? 'rgba(148,163,184,0.25)' : 'rgba(34,197,94,0.35)'
            }`,
            borderRadius: 20,
            padding: '3px 9px',
          }}
        >
          <div
            style={{
              width: 5,
              height: 5,
              borderRadius: '50%',
              background: isPostEvent ? '#94a3b8' : '#22c55e',
              boxShadow: isPostEvent ? 'none' : '0 0 5px #22c55e',
            }}
          />
          <span
            style={{
              fontSize: 10.5,
              fontWeight: 700,
              color: isPostEvent ? '#94a3b8' : '#22c55e',
              letterSpacing: '0.07em',
            }}
          >
            {isPostEvent ? 'POST-EVENT' : 'LIVE'}
          </span>
        </div>
        <button
          onClick={onMenuOpen}
          aria-label="Open menu"
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 4,
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Ic.Menu size={21} color="rgba(255,255,255,0.85)" />
        </button>
      </div>
    </div>
  );
}
